export default class Accordion {
  constructor(element) {
    this.el = element
    this.headers = this.el.querySelectorAll(".accordion-header")
    
    this.openClose = this.openClose.bind(this);
    this.init()
  }

  init() {
    this.headers.forEach(element => {
      element.addEventListener("click", e => {
        this.openClose(element)
      })
    });
  }

  openClose(element){
    let container = element.nextElementSibling;
    let containerText = container.querySelector(".accordion-text")
    let containerHeight = containerText.offsetHeight + "px"
    //console.log('containerHeight: ', containerHeight);
    
    if (element.classList.contains("open")){
      container.style.height = null; 
      element.classList.remove("open")
    }
    else{
      container.style.height = containerHeight;
      element.classList.add("open")
    }

  }
}
